/**
 * Persistent legal consent storage for Capacitor (iOS/Android).
 * Mirrors legal acceptance to native Preferences so it survives app restarts.
 * On web, this is a no-op (localStorage is already persistent).
 */

import { Preferences } from '@capacitor/preferences';
import { isCapacitor } from './platform';

const LEGAL_PREFS_KEY = 'trackio-legal-acceptance';
const LEGAL_STORAGE_KEY = 'trackio_legal_acceptance';

/**
 * On app cold start: restore legal acceptance from native Preferences into localStorage.
 * Call before React bootstraps (in main.jsx) so LegalComplianceWrapper sees it.
 */
export async function hydrateLegalFromNativeStorage() {
  if (!isCapacitor()) return;
  try {
    const { value } = await Preferences.get({ key: LEGAL_PREFS_KEY });
    if (value && typeof value === 'string') {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(LEGAL_STORAGE_KEY, value);
      }
    }
  } catch (_) {}
}

/**
 * After legal acceptance: mirror from localStorage to native Preferences.
 */
export async function persistLegalToNativeStorage() {
  if (!isCapacitor()) return;
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(LEGAL_STORAGE_KEY) : null;
    if (raw) {
      await Preferences.set({ key: LEGAL_PREFS_KEY, value: raw });
    }
  } catch (_) {}
}

/**
 * On logout: clear legal acceptance from native storage.
 */
export async function clearLegalFromNativeStorage() {
  if (!isCapacitor()) return;
  try {
    await Preferences.remove({ key: LEGAL_PREFS_KEY });
  } catch (_) {}
}
